import {
	PostInvestorDraftInstanceRes,
	VestingTermSimplifiedRes,
} from '@dealstack/shared/lib/generated';
import { Table } from '@dealstack/frontend/shared/components/Table/Table/Table';
import { useVestingTable } from '@dealstack/frontend/shared/components/Investors/Substeps/VestingTable/useVestingTable';

interface Props {
	investors?: PostInvestorDraftInstanceRes[];
	vestingTerms?: VestingTermSimplifiedRes[];
	vestingTermsChosen?: Map<string, string>;
	onVestingTermChange: (investorId: string) => (vestingTermId: string) => void;
}

export const VestingTable = ({
	investors,
	vestingTerms,
	vestingTermsChosen,
	onVestingTermChange,
}: Props) => {
	const { tableInstance } = useVestingTable(
		onVestingTermChange,
		investors,
		vestingTerms,
		vestingTermsChosen
	);

	return (
		<div className="mt-10">
			<Table tableInstance={tableInstance} />
		</div>
	);
};
